import { JetView } from "webix-jet";
import "@wbx/view-codemirror-editor";

const typeHash = {
	css: ["css", "less"],
	go: ["go"],
	htmlmixed: ["html", "xml", "svg"],
	javascript: ["js", "mjs", "json", "ts", "coffee"],
	markdown: ["md"],
	php: ["php", "phtml", "php3", "php4", "php5", "php7", "php-s", "pht", "phar"],
	python: ["py", "pyc", "pyd", "pyo", "pyw", "pyz"],
	sql: ["sql", "sqlite3", "sqlite", "db"],
	yaml: ["yaml", "yml"],
	shell: ["sh"],
};

export default class EditorView extends JetView {
	config() {
		const _ = this.app.getService("locale")._;

		this.File = this.getParam("file");
		const fileType = this.GetFileType(this.File);

		return {
			type: "wide",
			rows: [
				{
					view: "toolbar",
					padding: { left: 28, right: 4 },
					cols: [
						{
							view: "button",
							localId: "saveBtn",
							type: "icon",
							label: _("Save"),
							icon: "wxi-check",
							css: "webix_primary webix_fmanager_editor_save",
							width: 90,
							hotkey: "Ctrl+S",
							click: () => this.Save(),
						},
						{ width: 10 },
						{
							view: "label",
							label: " ",
							localId: "name",
							css: "webix_fmanager_editor_name",
						},
						{ gravity: 0.3 },
						{
							view: "icon",
							icon: "wxi-close",
							hotkey: "esc",
							click: () => this.Confirm(),
						},
					],
				},
				{
					view: "codemirror-editor",
					localId: "editor",
					mode: fileType,
					theme: webix.skin.$name === "contrast" ? "monokai" : "default",
				},
			],
		};
	}

	init() {
		this.$$("name").setValue(
			`<div class="filename">${this.ClipName(
				this.File.id
			)}</div><span class="extension">.${this.File.$ext}</span>`
		);

		const editor = this.$$("editor");
		webix.extend(editor, webix.ProgressBar);
		editor.showProgress({
			type: "top",
		});

		this.app
			.getService("operations")
			.read(this.File.id)
			.then(text => {
				this._oldValue = text;
				editor.getEditor(true).then(() => {
					editor.setValue(text);
				});
			})
			.finally(() => {
				editor.hideProgress();
			});

		editor.getEditor(true).then(editorObj => {
			editorObj.on("changes", () => this.TextChanged(editor));
		});
	}

	Back() {
		this.show("/top", { params: { state: this.getParam("state") } });
	}
	Confirm() {
		const _ = this.app.getService("locale")._;
		if (this._changed)
			webix
				.confirm({
					text: _("Are you sure you want to exit without saving?"),
				})
				.then(() => this.Back());
		else this.Back();
	}

	Save() {
		const content = this.$$("editor").getValue();
		this.app.getService("operations").write(this.File.id, content);
		this._oldValue = content;
		this.ChangeTextState(false);
	}

	GetFileType(file) {
		if (file.value === "Dockerfile") return "dockerfile";

		if (file.$ext) {
			for (var type in typeHash) {
				if (typeHash[type].indexOf(file.$ext) !== -1) {
					return type;
				}
			}
		}
		return "htmlmixed"; // the most versatile mode
	}

	TextChanged(editor) {
		const isEqual = editor.getValue() == this._oldValue;
		// if current state does not correspond to _changed flag
		this.ChangeTextState(!isEqual);
	}

	ChangeTextState(state) {
		if (state === !!this._changed) return;
		this._changed = state;
		const button = this.$$("saveBtn");
		button.config.icon = state ? "webix_fmanager_icon fmi-circle" : "wxi-check";
		button.refresh();
	}

	ClipName(path) {
		if (!path) return "";
		const parts = path.split(".");
		return parts.slice(0, parts.length - 1).join(".");
	}
}
